<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/" (click)="navCtrl.back()"></ion-back-button>
    </ion-buttons>
    <ion-title>
      <!-- <p> {{ results.eventName }} </p> -->
      {{ 'MY_ACTIVITIES' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="colored" >
  <div class="main-block" >
  <!-- style="margin-top: -50px !important;"> -->
    <div id="mapid" *ngIf="!google">
    </div>

    <div #map id="map" *ngIf="google">

    </div>
  </div>
  <div>
    <ion-grid>
      <div class="background-wrapper-prefix"></div>

      <ion-row>
        <ion-col size="12" class="column-header text-centered text-large">
          <span style="font-size: 22px;">{{ 'EVENT_DISTANCE' | translate }}</span>
          <span *ngIf="trackingService.options.distanceUnit == distanceUnit.KM"> {{ (results?.totalDistance /
            1000).toFixed(2) }} km </span>
          <span *ngIf="trackingService.options.distanceUnit == distanceUnit.MILES"> {{ (results?.totalDistance /
            1000 * 0.621371).toFixed(2) }} {{ 'MILES' | translate }} </span>
        </ion-col>
      </ion-row>
      <hr class="full-width">
      <ion-row>
        <ion-col size="12" class="column-header text-centered text-large">
          <span style="font-size: 25px;">{{ 'TOTAL_DURATION' | translate }}</span>
          <span> {{ results?.totalTimeFormatted }} </span>
        </ion-col>
      </ion-row>
      <hr class="full-width">
      <ion-row>
        <ion-col size="12" class="column-header text-centered text-large">
          <span style="font-size: 25px;">{{ 'TOTAL_ALTITUDE' | translate }}</span>
          <!-- <span> {{ calcAltitude() | number: '1.0-0' }}</span> -->
          <span> {{ totalAltitude }}</span>

        </ion-col>
      </ion-row>
      <hr class="full-width">
      <ion-row class="block-centered" *ngIf="results?.totalDistance > 1000 && results?.kmStatistics.length > 0">
        <ion-list class="full-width"  >
          <ion-item class="flex-space-between item-transparent no-margin-bottom">
            <span>{{ 'EVENT_DISTANCE' | translate }}</span>
            <span>{{ 'TOTAL_DURATION' | translate }}</span>
            <span>{{ 'TOTAL_ALTITUDE' | translate }}</span>
          </ion-item>
          <ion-item class="flex-space-end item-transparent no-margin-top no-margin-bottom">
            <img src="../../../assets/imgs/uphill-icon.png" style="height: 40px; width: 40px;" />
            <img src="../../../assets/imgs/downhill-icon.png"
              style="height: 40px; width: 40px; margin-left:25px; margin-right: 15px;" />
          </ion-item>
          <ion-item *ngFor="let result of results.kmStatistics; index as i"
            class="flex-space-around item-transparent no-margin-top" no-margin>
            <span style="color: white; width: 20%; text-align: end;"
              *ngIf="trackingService.options.distanceUnit == distanceUnit.KM">{{ i + 1 }} km </span>
            <span style="color: white; width: 20%; text-align: end;"
              *ngIf="trackingService.options.distanceUnit == distanceUnit.MILES">{{ i + 1 }} {{ 'MILES' | translate }}
            </span>
            <span style="color: white; width: 35%; text-align: end;">{{ result?.timeFormatted }}</span>
            <span style="color: white; width: 15%; text-align: end;">{{ result?.gain }}</span>
            <span style="color: white; width: 15%; text-align: end; margin-right: 20px;">{{ result?.loss }}</span>
          </ion-item>
        </ion-list>
      </ion-row>


      <ion-row class="graph" *ngIf="totalAltitude > 0">
        <line-chart [statistics]="results"></line-chart>
      </ion-row>
      <ion-row>
        <ion-col size="8" *ngIf="detector.isForestApp()">
          <ion-button expand="block" class="bordered item-transparent"
            (click)="onTrainingRedirect()"> {{ 'MY_TRAINING' | translate }}
          </ion-button>
        </ion-col>
        <ion-col size="8" *ngIf="!detector.isForestApp()">
          <ion-button class="bordered item-colored"  expand="block" (click)="onResultsRedirect()">{{ 'GLOBAL_RANKLIST'
            | translate }}
          </ion-button>
        </ion-col>
        <ion-col size="2" class="centered">
          <ion-button fill="clear" (click)="shareInstagram()">
            <ion-icon class="large" name="logo-instagram"></ion-icon>
          </ion-button>
        </ion-col>
        <ion-col size="2" class="centered">
          <ion-button fill="clear" (click)="shareFacebook()">
            <ion-icon class="large" name="logo-facebook"></ion-icon>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>